<div class="dashboard-container">
  <div class="dashboard-topbar">
    <div class="topbar-left">
      <h1>Dashboard</h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> <span>Dashboard</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp() }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <button
        class="btn btn-outline btn-sm"
        type="button"
        (click)="refresh()"
        [disabled]="isLoading()"
        title="Refresh dashboard"
      >
        <i class="bi bi-arrow-clockwise" [class.spin]="isLoading()"></i>
        Refresh
      </button>
      <button
        class="btn btn-outline btn-sm"
        type="button"
        (click)="exportData()"
      >
        <i class="bi bi-download"></i> Export
      </button>
    </div>
  </div>

  @if (isLoading()) {
    <div class="dash-loading" role="status" aria-live="polite">
      <div class="dash-spinner"></div>
      <span>Loading dashboard…</span>
    </div>
  }

  <div class="kpi-grid" [class.is-loading]="isLoading()">
    <div
      class="kpi-card alert"
      [routerLink]="['/check-in']"
      [queryParams]="{ status: 'overdue' }"
    >
      <div class="kpi-top">
        <div>
          <div class="kpi-label">Overdue Returns</div>
          <div class="kpi-value">{{ overdueCount() }}</div>
        </div>
        <div class="kpi-icon red"><i class="bi bi-exclamation-circle"></i></div>
      </div>
      <div class="kpi-footer"><span class="badge danger">Check-In</span></div>
    </div>

    <div class="kpi-card alert" routerLink="/check-in">
      <div class="kpi-top">
        <div>
          <div class="kpi-label">Due Today</div>
          <div class="kpi-value">{{ equipmentStats().dueToday }}</div>
        </div>
        <div class="kpi-icon blue"><i class="bi bi-calendar-check"></i></div>
      </div>
      <div class="kpi-footer">
        <span class="sub-text">Returns due today</span>
      </div>
    </div>

    <div class="kpi-card alert" routerLink="/low-stock">
      <div class="kpi-top">
        <div>
          <div class="kpi-label">Low Stock</div>
          <div class="kpi-value">{{ lowStockCount() }}</div>
        </div>
        <div class="kpi-icon amber">
          <i class="bi bi-exclamation-triangle"></i>
        </div>
      </div>
      <div class="kpi-footer">
        <span class="badge warning">Current Stock</span>
      </div>
    </div>

    <div class="kpi-card alert" routerLink="/current-stock">
      <div class="kpi-top">
        <div>
          <div class="kpi-label">Out of Stock</div>
          <div class="kpi-value">{{ outOfStockCount() }}</div>
        </div>
        <div class="kpi-icon red"><i class="bi bi-x-circle"></i></div>
      </div>
      <div class="kpi-footer">
        <span class="badge danger">Zero on hand</span>
      </div>
    </div>

    <div class="kpi-card alert" routerLink="/damaged-lost">
      <div class="kpi-top">
        <div>
          <div class="kpi-label">Damaged / Lost</div>
          <div class="kpi-value">{{ damagedCount() }}</div>
        </div>
        <div class="kpi-icon red"><i class="bi bi-tools"></i></div>
      </div>
      <div class="kpi-footer">
        <span class="badge danger">Damaged / Lost</span>
      </div>
    </div>

    <div class="kpi-card alert" routerLink="/maintenance-jobs">
      <div class="kpi-top">
        <div>
          <div class="kpi-label">Open Maintenance</div>
          <div class="kpi-value">{{ openMaintenanceCount() }}</div>
        </div>
        <div class="kpi-icon amber">
          <i class="bi bi-wrench-adjustable"></i>
        </div>
      </div>
      <div class="kpi-footer">
        <span class="badge warning">Pending + in progress</span>
      </div>
    </div>
  </div>

  <section class="stock-lanes" [class.is-loading]="isLoading()">
    <div class="lanes-intro">
      <h2>Your Stock</h2>
    </div>

    <div class="lanes-grid">
      <article class="lane lane-consumable">
        <div class="lane-badge">
          <i class="bi bi-box-seam"></i>
          Consumables
        </div>
        <h3>Stock you use up</h3>

        <div class="lane-hero">
          <div class="lane-hero-main">
            <span class="lane-hero-value">{{ nonRentableActiveSkus() }}</span>
            <span class="lane-hero-label"
              >active products in the catalogue</span
            >
          </div>
          <div class="lane-hero-side">
            <span class="lane-hero-value lane-hero-value-sm">{{
              formatCurrency(inventoryValue())
            }}</span>
            <span class="lane-hero-label">on-hand value</span>
          </div>
        </div>

        <ul class="lane-facts">
          <li>
            <span class="fact-label">Received today</span>
            <span class="fact-value">{{ goodsReceivedToday() }}</span>
          </li>
          <li>
            <span class="fact-label">Issued today</span>
            <span class="fact-value">{{ issuesToday() }}</span>
          </li>
        </ul>

        <div class="lane-actions">
          <a routerLink="/current-stock" class="lane-btn lane-btn-primary">
            Open Current Stock
            <i class="bi bi-arrow-right"></i>
          </a>
          <a routerLink="/issue-stock" class="lane-btn lane-btn-ghost">
            Issue Stock
          </a>
          <a
            routerLink="/item-master"
            [queryParams]="{ rentable: 'false' }"
            class="lane-btn lane-btn-ghost"
          >
            Register Items
          </a>
        </div>
      </article>

      <article class="lane lane-rental">
        <div class="lane-badge">
          <i class="bi bi-arrow-left-right"></i>
          Rentals
        </div>
        <h3>Items that come back</h3>

        <div class="lane-hero">
          <div class="lane-hero-main">
            <span class="lane-hero-value">{{ rentableAvailable() }}</span>
            <span class="lane-hero-label">ready to issue now</span>
          </div>
          <div class="lane-hero-side">
            <span class="lane-hero-value lane-hero-value-sm">{{
              rentableCheckedOut()
            }}</span>
            <span class="lane-hero-label">out with customers</span>
          </div>
        </div>

        <ul class="lane-facts">
          <li>
            <span class="fact-label">Booked / reserved</span>
            <span class="fact-value">{{ reservedCount() }}</span>
          </li>
          <li>
            <span class="fact-label">In repair</span>
            <span class="fact-value">{{ inRepairCount() }}</span>
          </li>
        </ul>

        <div class="lane-actions">
          <a routerLink="/check-out" class="lane-btn lane-btn-primary">
            Open Issue Items
            <i class="bi bi-arrow-right"></i>
          </a>
          <a routerLink="/check-in" class="lane-btn lane-btn-ghost">
            Check-In / Return
          </a>
          <a routerLink="/reservations" class="lane-btn lane-btn-ghost">
            Reservations
          </a>
        </div>
      </article>
    </div>
  </section>

  <div class="lists-grid">
    <section class="card">
      <div class="card-header">
        <h3><i class="bi bi-exclamation-circle"></i> Overdue returns</h3>
        <a routerLink="/check-in" class="panel-link"
          >Check-In <i class="bi bi-arrow-right"></i
        ></a>
      </div>
      <div class="card-body">
        <div class="activity-list">
          @for (row of overdueReturns(); track row.id) {
            <a class="activity-item" routerLink="/check-in">
              <div class="activity-content">
                <span class="activity-description">{{
                  checkoutLabel(row)
                }}</span>
                <span class="activity-time"
                  >Due {{ formatDate(row.dueDate) }}</span
                >
              </div>
            </a>
          } @empty {
            <div class="empty-state compact">
              <p>No overdue returns</p>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="card">
      <div class="card-header">
        <h3><i class="bi bi-exclamation-triangle"></i> Low stock</h3>
        <a routerLink="/low-stock" class="panel-link"
          >Low Stock <i class="bi bi-arrow-right"></i
        ></a>
      </div>
      <div class="card-body">
        <div class="activity-list">
          @for (row of lowStockAlerts(); track row.id) {
            <a class="activity-item" routerLink="/current-stock">
              <div class="activity-content">
                <span class="activity-description">{{
                  snapshotLabel(row)
                }}</span>
                <span class="activity-time">{{ row.quantity }} on hand</span>
              </div>
            </a>
          } @empty {
            <div class="empty-state compact">
              <p>No low stock lines</p>
            </div>
          }
        </div>
      </div>
    </section>

    <section class="card">
      <div class="card-header">
        <h3><i class="bi bi-clock-history"></i> Recent activity</h3>
        <a routerLink="/issued-stock" class="panel-link"
          >Issued Stock <i class="bi bi-arrow-right"></i
        ></a>
      </div>
      <div class="card-body">
        <div class="activity-list">
          @for (row of recentFeed(); track row.id) {
            <a class="activity-item" [routerLink]="row.route">
              <div class="activity-content">
                <span class="activity-description">
                  {{ row.kind === "issue" ? "Issued" : "Checked out" }} ·
                  {{ row.title }} · {{ row.detail }}
                </span>
                <span class="activity-time">{{ formatDate(row.date) }}</span>
              </div>
            </a>
          } @empty {
            <div class="empty-state compact">
              <p>No recent issues or checkouts</p>
            </div>
          }
        </div>
      </div>
    </section>
  </div>
</div>

<div class="toast-container" [class.show]="showToast()">
  <div
    class="toast"
    [class.success]="toastType() === 'success'"
    [class.error]="toastType() === 'error'"
    [class.info]="toastType() === 'info'"
  >
    <div class="toast-icon">
      @if (toastType() === "error") {
        <i class="bi bi-x-circle-fill"></i>
      } @else if (toastType() === "info") {
        <i class="bi bi-info-circle-fill"></i>
      } @else {
        <i class="bi bi-check-circle-fill"></i>
      }
    </div>
    <div class="toast-content">
      <div class="toast-title">
        @if (toastType() === "error") {
          Error
        } @else if (toastType() === "info") {
          Info
        } @else {
          Success
        }
      </div>
      <div class="toast-message">{{ toastMessage() }}</div>
    </div>
    <button class="toast-close" type="button" (click)="closeToast()">
      <i class="bi bi-x"></i>
    </button>
  </div>
</div>
